import WatchPills from '@/components/watch/pillboxV2/Pills'
import WatchPillsManage from '@/components/watch/pillboxV2/PillsManage'
import WatchPillsHistory from '@/components/watch/pillboxV2/PillsHistory'
import WatchPillsManagePillForm from '@/components/watch/pillboxV2/PillForm'
import ButtonAddPill from '@/components/watch/pillboxV2/ButtonAddPill'
import ButtonBarManage from '@/components/watch/pillboxV2/ButtonBarManage'

export default [
	{
		path: 'pillbox2',
		redirect: 'pillbox2/manage/bydate',
		name: 'WatchPills',
		component: WatchPills,
		props: (route) => ({ profile: route.params.profile }),
		children: [
			{
				path: 'manage',
				redirect: 'manage/bydate',
				name: 'WatchPillsManage',
				component: WatchPillsManage,
				children: [
					{
						path: 'add',
						name: 'WatchPillsManagePillAdd',
						components: {
							default: WatchPillsManagePillForm,
							slotheader: ButtonAddPill
						},
						props: {
							default: (route) => ({
								user_uid: route.params.user_uid,
								watch_id: route.params.watch_id,
								action: 'add'
							}),
							slotheader: true
						}
					},
					{
						path: ':pill_id/edit',
						name: 'WatchPillsManagePillEdit',
						components: {
							default: WatchPillsManagePillForm,
							slotheader: ButtonAddPill
						},
						props: {
							default: (route) => ({
								user_uid: route.params.user_uid,
								watch_id: route.params.watch_id,
								pill_id: route.params.pill_id,
								data: route.params.data,
								action: 'edit'
							}),
							slotheader: true
						}
					}
				]
			},
			{
				path: 'manage/bydate',
				name: 'WatchPillsManageByDate',
				components: {
					default: WatchPillsManage,
					slotheader: ButtonAddPill,
					slotbar: ButtonBarManage
				},
				props: {
					default: true,
					slotheader: true,
					slotbar: true
				}
			},
			{
				path: 'manage/actives',
				name: 'WatchPillsManageActives',
				components: {
					default: WatchPillsManage,
					slotheader: ButtonAddPill,
					slotbar: ButtonBarManage
				},
				props: {
					default: true,
					slotheader: true,
					slotbar: true
				},
			},
			{
				path: 'manage/all',
				name: 'WatchPillsManageAll',
				components: {
					default: WatchPillsManage,
					slotheader: ButtonAddPill,
					slotbar: ButtonBarManage
				},
				props: {
					default: true,
					slotheader: true,
					slotbar: true
				},
			},
			{
				path: 'history',
				name: 'WatchPillsHistory',
				component: WatchPillsHistory,
				props: true
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/watch/pillboxV2.js